import { getValue } from "@utils/lodash";
import "./index.scss";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function CommonDataImported(props: any) {
  const navigate = useNavigate();
  const handleNavigate = (name: string) => {
    switch (name) {
      case "SELF_COMPLIANCE_CONFIG":
        return navigate(`/file-logs/SELF_COMPLIANCE`);
      case "VENDOR_USER":
        return navigate(`/file-logs/USER`);
      case "VENDOR_HEADCOUNT":
        return navigate(`/file-logs/HEADCOUNT`);
      default:
        return navigate(`/file-logs/${name}`);
    }
  };
  return (
    <>
      <div className="popup-wrapper__details text-center">
        <div className="popup-wrapper__close-btn">
          <img
            src="/images/close-black.svg"
            className="img-fluid cursor-pointer"
            onClick={() => {
              props.closePopup();
            }}
          />
        </div>
        <h6 className="popup-wrapper__data-imported">Data Imported</h6>
        <img src="/images/popup/transfer-files.svg" className="img-fluid" />
        <h5 className="popup-wrapper__records">
          {/* {getValue(props, `response.counts.totalRecords`, 0)} Records Found */}
        </h5>
        <p>
          {/* {getValue(props, `response.counts.failedRecords`, 0)} Records Import
					Failed -{" "} */}
          <div
            // to={`/file-logs/${getValue(props, `type`, "")}`}
            onClick={() => handleNavigate(getValue(props, `type`, ""))}
            style={{ color: "blue", cursor: "pointer" }}
          >
            Click here to view status
          </div>
        </p>
      </div>
    </>
  );
}
